import $ from "jquery";

const exportGuidesSingle = () => {
  const init = () => {
    timeReading();
    navigateMobile();
    renderIframe();
  };

  const isElementInViewport = (el) => {
    var elementTop = el.offset().top - 125;
    var elementBottom = elementTop + el.height();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
  };

  const timeReading = () => {
    const el = {
      progress: ".js-progress-bar",
      content: ".js-content",
      contentChapter: ".js-content-chapter",
      select: ".js-MobileNavChapter",
    };

    if (!$(el.progress).length) return;

    $(function () {
      const progress = $(el.progress);
      const bodyHeight = $(el.content).height();

      const progressMax = parseInt(progress.attr("max"));

      $(document).on("scroll", function (e) {
        e.preventDefault();

        const currentPosition = $(window).scrollTop();
        const finalCount = (currentPosition * progressMax) / bodyHeight;

        $(el.progress).attr("value", finalCount);

        $(el.contentChapter).each(function () {
          if (isElementInViewport($(this))) {
            $(`.js-chapter-link[href="#${$(this).attr("id")}"]`).addClass(
              "Active"
            );
            const text = $(
              `${el.select} + div a[href="#${$(this).attr("id")}"]`
            ).text();
            $(`${el.select} span`).text(text);
          } else {
            $(`.js-chapter-link[href="#${$(this).attr("id")}"]`).removeClass(
              "Active"
            );
          }
        });
      });
    });
  };

  const navigateMobile = () => {
    const el = {
      select: ".js-MobileNavChapter",
    };

    if (!$(el.select).length) return;

    $(document).on("click", el.select, function (e) {
      e.preventDefault();
      $(`${el.select} + div`).toggle(300);
    });

    $(document).on("click", `${el.select} + div a`, function (e) {
      e.preventDefault();
      const positionTo = $($(this).attr("href")).position().top;

      const offset = window.screen.width < 768 ? 620 : 420;

      window.scrollTo(window.scrollX, positionTo - offset);
      $(this).parent().hide(300);
    });
  };

  const renderIframe = () => {
    const el = {
      iframe: "iframe",
    };

    if (!$(el.iframe).length) return;

    $(() => {
      $(el.iframe).each(function () {
        $(this).attr("src", $(this).data("src-cmplz"));
      });
    });
  };

  init();
};

try {
  exportGuidesSingle();
} catch (error) {
  console.error("exportGuidesSingle", error);
}
